import { Icon, List, Text } from "@shopify/polaris"
import { ChevronDownIcon, ChevronUpIcon } from "@shopify/polaris-icons"
import { uniqueId } from "lodash-es"
import { ProCollapsible } from "polaris-enhance"
import { useState } from "react"

import { TooltipByIcon } from "@/components"

import type { IProAskedQuestionsProps } from "./index"

export interface FAQProps extends IProAskedQuestionsProps {
  defaultOpen?: boolean
}

const FAQ = (props: FAQProps) => {
  const { title, list = [], desc, jumpUrl, defaultOpen = false } = props
  const [open, setOpen] = useState(defaultOpen)
  const collapsibleId = `faq-collapsible-${uniqueId()}`

  return (
    <div
      className="rounded-lg border border-[#e3e3e3] border-solid bg-white px-4 py-3 overflow-hidden cursor-pointer hover:bg-[#f7f7f7]"
      id={collapsibleId}
      onClick={() => setOpen((prev) => !prev)}
    >
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-1 min-w-0 flex-1">
          <Text variant="bodyMd" as="span" fontWeight="medium">
            {title}
          </Text>
          {jumpUrl && (
            <div
              className="shrink-0 h-5"
              onClick={(event) => event.stopPropagation()}
            >
              <TooltipByIcon content={t("LearnMore")} jumpUrl={jumpUrl} />
            </div>
          )}
        </div>
        <div className="shrink-0">
          <Icon source={open ? ChevronUpIcon : ChevronDownIcon} tone="base" />
        </div>
      </div>
      <ProCollapsible open={open} id={collapsibleId}>
        <div className="pt-1 flex flex-col gap-2">
          {desc && (
            <Text variant="bodyMd" as="p" tone="subdued">
              {desc}
            </Text>
          )}
          {list.length <= 1 ? (
            <Text variant="bodyMd" as="span" tone="subdued">
              {list[0]}
            </Text>
          ) : (
            <List type="bullet" gap="extraTight">
              {list.map((item, index) => (
                <List.Item key={index}>
                  <Text variant="bodyMd" as="span" tone="subdued">
                    {item}
                  </Text>
                </List.Item>
              ))}
            </List>
          )}
        </div>
      </ProCollapsible>
    </div>
  )
}

export default FAQ
